/** Split a pasted list on commas, semicolons and whitespace; empty entries vanish. */
export function codeList(text: string | undefined): string[] {
  return (text ?? '')
    .split(/[\s,;]+/)
    .map((code) => code.trim())
    .filter(Boolean)
}
